export const signedStatementsStoreKey = 'signedStatements';
